import React, { useEffect, useRef, useState } from "react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  MenuButtonBulletedList,
  MenuButtonOrderedList,
  MenuButtonBlockquote,
  RichTextEditor,
  type RichTextEditorRef,
  RichTextContent,
  RichTextReadOnly,
  MenuSelectFontFamily,
  MenuSelectFontSize,
  MenuSelectTextAlign,
} from "mui-tiptap";
import useExtensions from "./useExtensions";
import { useTranslationHook } from "../../hooks";

interface DescriptionEditorProps {
  initialText: string;
  isTender: boolean;
  isEditMode: boolean;
  onChange: (updatedText: string) => void;
}

const DescriptionEditor: React.FC<DescriptionEditorProps> = (
  props: DescriptionEditorProps
) => {
  const { t } = useTranslationHook();
  const { initialText, isTender, isEditMode, onChange } = props;
  const rteRef = useRef<RichTextEditorRef>(null);
  const [htmlResult, setHtmlResult] = useState("");

  const extensions = useExtensions({
    placeholder: t("generic.add-text"),
  });

  useEffect(() => {
    if (rteRef.current?.editor) {
      rteRef.current.editor.commands.setContent(initialText);
    }
  }, [initialText]);

  useEffect(() => {
    onChange && onChange(htmlResult);
  }, [htmlResult]);

  return (
    <div>
      {isTender === false && isEditMode && (
        <RichTextEditor
          ref={rteRef}
          extensions={extensions}
          onUpdate={(props) => {
            setHtmlResult(props.editor.getHTML());
          }}
          content={initialText}
          renderControls={() => (
            <MenuControlsContainer>
              <MenuSelectHeading />
              <MenuDivider />
              <MenuSelectFontSize />
              <MenuDivider />
              <MenuButtonBold />
              <MenuButtonItalic />
              <MenuDivider />
              <MenuButtonBulletedList />
              <MenuButtonOrderedList />
              <MenuDivider />
              <MenuSelectTextAlign />
              <MenuDivider />
              <MenuButtonBlockquote />
            </MenuControlsContainer>
          )}
          className="custom-editor"
        />
      )}
      {(isTender === true || !isEditMode) && (
        <RichTextReadOnly
          content={initialText}
          extensions={extensions}
        ></RichTextReadOnly>
      )}
    </div>
  );
};

export default DescriptionEditor;
